<template>
  <div class="max-w-6xl">
    <div class="flex items-center gap-3 mb-4">
      <div class="w-10 h-10 flex items-center justify-center rounded-lg bg-indigo-100 text-indigo-700">
        <i class="fa-regular fa-newspaper"></i>
      </div>
      <h1 class="text-xl font-bold text-gray-800">Noticias</h1>
    </div>

    <div class="border-b border-gray-200 mb-6">
      <nav class="flex flex-wrap gap-1 -mb-px">
        <button
          v-for="t in tabs"
          :key="t.id"
          type="button"
          :class="[
            'px-4 py-2 text-sm font-medium border-b-2 transition-colors',
            activeTab === t.id
              ? 'border-blue-500 text-blue-500'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
          ]"
          @click="activeTab = t.id"
        >
          {{ t.label }}
        </button>
      </nav>
    </div>

    <!-- v-if (no v-show): al volver a la pestaña Noticias se recargan las categorías -->
    <NoticiasList v-if="activeTab === 'news'" />
    <NoticiaCategories v-else />
  </div>
</template>

<script>
import NoticiasList from '@/components/noticias/NoticiasList.vue';
import NoticiaCategories from '@/components/noticias/NoticiaCategories.vue';

export default {
  name: 'NoticiasView',
  components: { NoticiasList, NoticiaCategories },
  data() {
    return {
      activeTab: 'news',
      tabs: [
        { id: 'news', label: 'Noticias' },
        { id: 'categories', label: 'Administrar Categorías' },
      ],
    };
  },
};
</script>
